__turbopack_context__.v({
  "alignCenter": "NkdnXa_alignCenter",
  "alignLeft": "NkdnXa_alignLeft",
  "alignRight": "NkdnXa_alignRight",
  "colorDecorator": "NkdnXa_colorDecorator",
  "olList": "NkdnXa_olList",
  "strong": "NkdnXa_strong",
  "textStyleBase": "NkdnXa_textStyleBase",
  "textStyleBlockquote": "NkdnXa_textStyleBlockquote",
  "textStyleH1": "NkdnXa_textStyleH1",
  "textStyleH2": "NkdnXa_textStyleH2",
  "textStyleH3": "NkdnXa_textStyleH3",
  "textStyleH4": "NkdnXa_textStyleH4",
  "textStyleH5": "NkdnXa_textStyleH5",
  "textStyleH6": "NkdnXa_textStyleH6",
  "textStyleLarge": "NkdnXa_textStyleLarge",
  "textStyleMicro": "NkdnXa_textStyleMicro",
  "textStyleNano": "NkdnXa_textStyleNano",
  "textStyleSmall": "NkdnXa_textStyleSmall",
  "ulList": "NkdnXa_ulList",
});
